<nz-spin [nzSpinning]="loading$ | async">
  <form nz-form class="form" [formGroup]="templateForm">
    <div class="drawer-form-wrapper">
      <div class="cta-wrapper w-50">
        <ng-container *ngIf="!isEditMode">
          <app-organization-search
            [disabled]="isEditMode"
            [isNullable]="false"
            [defaultSelectedOrg]="orgId"
            (orgChange)="orgChange($event)">
          </app-organization-search>
        </ng-container>

        <ng-container *ngIf="isEditMode">
          <app-organization-search
            [disabled]="isEditMode"
            [defaultSelectedOrg]="orgId"
            (orgChange)="orgChange($event)">
          </app-organization-search>
        </ng-container>
      </div>
      <div class="template-card">
        <div class="card-header mb-24">
          <div class="card-header-left">
            <img src="/assets/images/logo-lg.png" alt="logo" />
          </div>
          <div class="card-header-right">
            <h3 class="header-title">Organization Name</h3>
            <p class="header-desc">Organization Address</p>
          </div>
        </div>
        <div class="card-header mb-24">
          <div class="card-header-left">
            <h3 class="title s-18">Student Name</h3>
          </div>
          <div class="card-header-right">
            <h3 class="title s-18">
              Supervisor : <span class="header-sec-desc">Supervisor Name</span>
            </h3>
          </div>
        </div>

        <nz-form-item *ngIf="!isEditMode">
          <span nz-checkbox formControlName="isDefault" class="custom-checkbox"
            >Set as Default</span
          >
        </nz-form-item>
        <div class="form-grid" *ngIf="!isEditMode">
          <nz-form-item>
            <nz-form-label nzRequired="" nzFor="name"
              >Template Name</nz-form-label
            >
            <nz-form-control [nzErrorTip]="nameErrorTpl">
              <input
                nz-input
                id="name"
                formControlName="templateName"
                placeholder="Enter template name" />
              <ng-template #nameErrorTpl let-control>
                <ng-container *ngIf="control.hasError('required')"
                  >Please enter template</ng-container
                >
                <ng-container
                  *ngIf="
                    control.hasError('maxlength') ||
                    control.hasError('minlength')
                  ">
                  Template name must be between 3 and 250 characters
                </ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div class="checkbox-grid mb-16" formArrayName="templateFields">
          <ng-container *ngIf="templateFieldsControls.length > 0">
            <div
              class="wrapper"
              *ngFor="let ctrl of templateFieldsControls; let i = index"
              [formGroup]="ctrl">
              <span
                nz-checkbox
                [nzChecked]="ctrl.value.isSelected"
                (nzCheckedChange)="toggleSelection(i, $event)"
                >{{ ctrl.value.fieldName }}</span
              >
            </div>
          </ng-container>
        </div>
        <nz-form-item>
          <span
            nz-checkbox
            formControlName="isIncludeStrategyGuidelines"
            class="custom-checkbox"
            >Include Strategy Guidelines</span
          >
        </nz-form-item>
      </div>
      <nz-table
        #basicTable
        [nzData]="listOfTableRow"
        nzTableLayout="fixed"
        [nzShowPagination]="false"
        formArrayName="templateSections">
        <tbody cdkDropList (cdkDropListDropped)="drop($event)">
          <tr
            *ngFor="let section of templateSections.controls; let i = index"
            [formGroupName]="i"
            cdkDrag>
            <td>
              <div class="row">
                <div class="left">
                  <button
                    nz-button
                    type="button"
                    nzType="default"
                    cdkDragHandle>
                    <svg-icon
                      src="/assets/icon/icon-drag.svg"
                      class="icon s-20"
                      aria-label="Drag"></svg-icon>
                  </button>
                  <span class="badge">Section {{ i + 1 }}</span>
                  <h4 class="title s-18">{{ section.value.sectionName }}</h4>
                </div>
                <div class="right">
                  <nz-switch formControlName="isSelected"></nz-switch>
                </div>
              </div>
              <div
                *ngIf="
                  section.value.sectionName === 'Challenging Behavior' &&
                  section.value.isSelected
                "
                class="custom-data-wrapper mb-16"
                cdkDropList
                id="behaviorSectionsList"
                [cdkDropListData]="behvaiorSections"
                [cdkDropListConnectedTo]="['customQuestionsList']"
                (cdkDropListDropped)="handleBehaviorSectionDrop($any($event))">
                <div
                  class="data custom-question-item"
                  *ngFor="
                    let behaviorSection of behvaiorSections;
                    let j = index
                  "
                  cdkDrag
                  [cdkDragData]="behaviorSection">
                  <span
                    class="drag-handle"
                    cdkDragHandle
                    aria-label="Drag question to reorder">
                    <svg-icon
                      src="/assets/icon/icon-drag.svg"
                      class="icon s-20"
                      aria-label="Drag"></svg-icon>
                  </span>
                  <span
                    nz-checkbox
                    class="question-label"
                    [nzDisabled]="behaviorSection.questionId !== 0"
                    [nzChecked]="
                      behaviorSection.isSelected ||
                      behaviorSection.questionId !== 0
                    "
                    (nzCheckedChange)="
                      toggleQuestionnairesSelection(
                        behaviorSection.sectionId,
                        $event
                      )
                    "
                    [attr.aria-label]="behaviorSection.value">
                    {{ behaviorSection.value }}
                  </span>
                </div>
              </div>
              <div
                *ngIf="
                  section.value.sectionName === 'Custom Questions' &&
                  section.value.isSelected
                "
                class="custom-data-wrapper mb-16"
                cdkDropList
                id="customQuestionsList"
                [cdkDropListData]="customQuestions"
                [cdkDropListConnectedTo]="['behaviorSectionsList']"
                (cdkDropListDropped)="handleCustomQuestionDrop($event)">
                <div *ngIf="customQuestions.length === 0" class="no-question">
                  No custom questions available.
                </div>
                <div
                  class="data custom-question-item"
                  *ngFor="let question of customQuestions; let j = index"
                  cdkDrag
                  [cdkDragData]="question">
                  <span
                    *ngIf="
                      templateQuestions &&
                      templateQuestions.includes(question.id)
                    "
                    class="drag-handle"
                    cdkDragHandle
                    aria-label="Drag question to reorder">
                    <svg-icon
                      src="/assets/icon/icon-drag.svg"
                      class="icon s-20"
                      aria-label="Drag"></svg-icon>
                  </span>
                  <span
                    nz-checkbox
                    class="question-label"
                    [nzChecked]="
                      templateQuestions &&
                      templateQuestions.includes(question.id)
                    "
                    (nzCheckedChange)="
                      toggleQuestionSelection(question.id, $event)
                    "
                    [attr.aria-label]="question.customQuestion">
                    {{ question.customQuestion }}
                  </span>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </nz-table>

      <div class="mt-16">
        <h3 class="title s-16 mb-8">Questionnaire Sections</h3>
        <p class="error-text mb-16">
          Note: You can’t move questionnaire sections above this section.
        </p>
      </div>
      <nz-table
        #plansTable
        [nzData]="planList"
        nzTableLayout="fixed"
        [nzShowPagination]="false"
        formArrayName="planSections"
        [nzNoResult]="noDataTemplate">
        <tbody cdkDropList (cdkDropListDropped)="handlePlanDrop($event)">
          <tr
            *ngFor="let plan of planList; let i = index"
            [formGroupName]="i"
            cdkDrag>
            <td>
              <div class="row">
                <div class="left">
                  <button
                    nz-button
                    type="button"
                    nzType="default"
                    cdkDragHandle>
                    <svg-icon
                      src="/assets/icon/icon-drag.svg"
                      class="icon s-20"
                      aria-label="Drag"></svg-icon>
                  </button>
                  <span class="badge"
                    >Section {{ templateSections.length + i + 1 }}</span
                  >
                  <h4 class="title s-18">{{ plan.name }}</h4>
                </div>
                <div class="right">
                  <nz-switch
                    formControlName="isSelected"
                    (ngModelChange)="
                      togglePlanSelection(i, $event)
                    "></nz-switch>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </nz-table>

      <div class="error-message" *ngIf="!isBehaviorSectionSelected">
        Select at least one challenging behavior section
      </div>
    </div>
    <div class="drawer-footer">
      <div class="footer-left">
        <button nz-button type="reset" nzType="default" (click)="onCancel()">
          Cancel
        </button>
      </div>
      <div class="footer-right">
        <button
          nz-button
          type="button"
          nzType="primary"
          (click)="submit()"
          [disabled]="!isFormValid">
          Save to My School
        </button>
        <button
          *ngIf="!isEditMode"
          nz-button
          type="button"
          nzType="primary"
          (click)="publish()"
          [disabled]="!isFormValid">
          Save to District Records
        </button>
      </div>
    </div>
  </form>
</nz-spin>
<ng-template #noDataTemplate>
  <div class="no-data-template"></div>
</ng-template>
